export default "__VITE_ASSET__DjXlnQR7__"